<template>
  <section class="main">
      <div class="content_page_title">
          <h1>Réinitialisation du mot de passe</h1>
      </div>
      <div class="main_content">

        <div v-if="expiredToken" class="form_message form_message_text error">
          <p>{{errorMsg}}</p>
        </div>

        <div class="form">
          <div v-if="tokenValidity">
            <form ref="form" v-on:submit.prevent>
                <div class="form">
                    <div class="form_message">
                        <div class="form_message_text">
                            Merci de bien vouloir inscrire votre nouveau mot de passe et de le confirmer.
                            <div class="note">(Il doit contenir au moins : 8 caractères, une majuscule, un caractère de type numérique)</div>
                        </div>
                    </div>
                    <div class="line half">
                        <div class="errorPassword" v-if="errorPassword">{{passwordErrorMessage}}</div>
                        <div class="form_group full">
                            <label for="mdp">Nouveau mot de passe *</label>
                            <input id="mdp" type="password" v-model="password" minlength="8" required placeholder="Entrez votre nouveau mot de passe"/>
                        </div>
                        <div class="form_group full">
                            <label for="confirmationMdp">Confirmez votre nouveau mot de passe *</label>
                            <input id="confirmationMdp" type="password" minlength="8" v-model="passwordConfirmation" required placeholder="Entrez une seconde fois votre nouveau mot de passe"/>
                        </div>
                    </div>
                    <div class="form_actions_bar">
                        <input type="submit" value ="Valider" class="blue button" @click="handleOk" />
                    </div>
                    <a href="index.html" class="button dark">Retour à l'accueil</a>
                </div>
            </form>
          </div>
        </div>
      </div>
    </section>
</template>
<script>

import axios from 'axios'

export default {
  name: 'ResetPassword',
  components: {},
  data() {
    return {
      token: null,
      expiredToken: false,
      tokenValidity: false,
      errorMsg: null,
      password: null,
      passwordConfirmation: null,
      errorPassword: null,
      passwordErrorMessage: null
    }
  },
  created() {

    // Redirection si token non fourni dans l'URL
    if(!this.$route.query.token) {
      this.$router.push('/');
    } else {
      this.token = this.$route.query.token;
    }

    // Vérification du token
    axios.get('utilisateur/checkPasswordToken', {
      params: {
        token: this.token
      }
    }).then(response => {
      if(!response.data.success){
        // Token expiré
        if(response.data.msg) {
          this.expiredToken = true;
          this.errorMsg = response.data.msg;
        } else {
          // Redirection si token incorrect
          this.$router.push('/');
        }
      } else {
        this.tokenValidity = true;
      }
    })
  },

  destroyed() {
    this.token = null;
    this.expiredToken = false;
    this.tokenValidity = false;
    this.errorMsg = null;
    this.password = null;
    this.passwordConfirmation = null;
    this.errorPassword = null;
    this.passwordErrorMessage = null;
  },
  methods: {
    handleOk() {
      if(this.$refs['form'].checkValidity()) {
        axios.get('/utilisateur/checkPassword', {
          params: {
            password: this.password,
            passwordConfirmation: this.passwordConfirmation
          }
        }).then(response => {
          if(!response.data.success) {
            this.errorPassword = true;
            this.passwordErrorMessage = response.data.msg;
          } else {
            this.errorPassword = false;
            axios.post('/utilisateur/changePassword', {
              token : this.token ,
              password: this.password
            }).then(() => {
              this.$router.push('/');
              this.$notify({
                group: 'general-notification',
                type: 'success',
                text: "Votre mot de passe a bien été mis à jour"
              });
            });
          }
        });
      }
    }
  }
}
</script>

<style scoped>

.error {
  color: #515151;
  font-size: 20px;
}

.errorPassword {
  font-size: 12px;
  color: red;
}
</style>
